import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";

const linkClass =
    "text-sm text-veda-onInverse/70 hover:text-veda-onInverse transition-colors";

export default function Footer() {
    return (
        <footer className="mt-24 border-t border-veda-border bg-veda-inverse text-veda-onInverse">
            <div className="veda-container grid gap-12 py-16 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
                <div>
                    <div className="flex items-center gap-2">
                        <span className="grid h-9 w-9 place-items-center bg-veda-onInverse/10">
                            <Leaf size={16} strokeWidth={1.5} />
                        </span>
                        <span className="font-display text-2xl">Sushen Herbs</span>
                    </div>
                    <p className="mt-4 max-w-sm text-sm leading-relaxed text-veda-onInverse/60">
                        Ayurvedic care, thoughtfully modern. Consult Vaidyas,
                        order authentic remedies, and stay well — rooted in
                        tradition, delivered simply.
                    </p>
                </div>

                <div>
                    <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-veda-onInverse/40">
                        Product
                    </p>
                    <ul className="mt-4 space-y-3">
                        <li>
                            <Link to="/" className={linkClass}>
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link to="/auth/register-doctor" className={linkClass}>
                                Join as a Vaidya
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-veda-onInverse/40">
                        Company
                    </p>
                    <ul className="mt-4 space-y-3">
                        <li>
                            <a href="mailto:hello@vedaheal.com" className={linkClass}>
                                Contact
                            </a>
                        </li>
                        <li>
                            <a href="#privacy" className={linkClass}>
                                Privacy
                            </a>
                        </li>
                        <li>
                            <a href="#terms" className={linkClass}>
                                Terms
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-veda-onInverse/40">
                        Care
                    </p>
                    <ul className="mt-4 space-y-3">
                        <li>
                            <a href="#faq" className={linkClass}>
                                FAQ
                            </a>
                        </li>
                        <li>
                            <a href="#returns" className={linkClass}>
                                Returns
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-veda-onInverse/10">
                <div className="veda-container flex flex-col items-start justify-between gap-2 py-6 text-xs text-veda-onInverse/50 md:flex-row md:items-center">
                    <span>
                        © {new Date().getFullYear()} Sushen Herbs. All rights reserved.
                    </span>
                    <span className="tracking-wide">
                        Made with care, rooted in Ayurveda.
                    </span>
                </div>
            </div>
        </footer>
    );
}
